/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Mode de saisie d'une commission variable.
 * @export
 */
export const TypeCommission = {
    Slider: 1,
    List: 2
} as const;
export type TypeCommission = typeof TypeCommission[keyof typeof TypeCommission];


export function instanceOfTypeCommission(value: any): boolean {
    for (const key in TypeCommission) {
        if (Object.prototype.hasOwnProperty.call(TypeCommission, key)) {
            if (TypeCommission[key as keyof typeof TypeCommission] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TypeCommissionFromJSON(json: any): TypeCommission {
    return TypeCommissionFromJSONTyped(json, false);
}

export function TypeCommissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeCommission {
    return json as TypeCommission;
}

export function TypeCommissionToJSON(value?: TypeCommission | null): any {
    return value as any;
}

export function TypeCommissionToJSONTyped(value: any, ignoreDiscriminator: boolean): TypeCommission {
    return value as TypeCommission;
}

